module.exports = __webpack_public_path__ + "media/images/share-whatsapp-b5f1daf7b20bbe82b7750e650dd5370e.svg";